import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getLearningPlanItemsPath = (endpoint) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    return `${prefix}/learning-plan-items/${endpoint}`;
};

export const fetchLearningPlanItemsStudentDaterangeCompleted = (params) => async (dispatch) => {
    const path = getLearningPlanItemsPath('student-daterange-completed');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const updateLearningPlanItems = (params) => async (dispatch) => {
    const path = getLearningPlanItemsPath('');
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}